// import { canUseDOM } from 'exenv';

export function magazineIssuePostsLoading(resp = {}, store = {}) {
  return {
    type: 'MAGAZINE_ISSUE_POSTS_LOADING',
    magazineIssuePosts: resp,
    store
  };
}

export function magazineIssuePostsLoaded(resp = {}, store = {}) {
  return {
    type: 'MAGAZINE_ISSUE_POSTS_LOADED',
    magazineIssuePosts: resp,
    store
  };
}

export function magazineIssuePostsError(error, store = {}) {
  return {
    type: 'MAGAZINE_ISSUE_POSTS_ERROR',
    magazineIssuePosts: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
